<template>
  <div id="app">
    <v-card>
      <v-img max-height="85" src="@/assets/img/background.png">
        <v-app-bar flat class="mt-2" color="rgba(0, 0, 0, 0)">
          <v-btn color="white" @click="goBack()" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <p class="text-white-title mt-4">Profile</p>
        </v-app-bar>
      </v-img>
    </v-card>
    <div class="d-flex justify-center mx-2 mt-15 w-100" fluid>
      <v-card class="px-2 mt-15 w-50">
        <v-content class="pa-0 mt-0" style="margin-top: -4rem !important;">
          <v-container fluid>
            <v-layout justify-center align-center>
              <v-avatar size="150">
                <img :src="res_userInfo.image_url" alt="John" />
              </v-avatar>
            </v-layout>
          </v-container>
        </v-content>
        <ValidationObserver ref="form" v-slot="{ handleSubmit }">
          <v-form @submit.prevent="handleSubmit(submitForm)">
            <v-row>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pb-0">
                <p class="app-title-small text-sm ma-0">
                  Select Profile Picture
                </p>
                <ValidationProvider
                  v-slot="{ errors }"
                  name="Profile Picture"
                  rules="required"
                >
                  <v-file-input
                    accept="image/*"
                    v-model="image"
                    :error-messages="errors"
                    label="Click to select image"
                  ></v-file-input>
                </ValidationProvider>
              </v-col>
              <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-2">
                <v-btn
                  type="submit"
                  color="#f7941d"
                  class="text-center ma-1"
                  width="100%"
                  dark
                  :loading="loading"
                  small
                >
                  <span class="text-capitalize">Change</span>
                </v-btn>
                <v-btn
                  color="#008ef8"
                  @click.prevent="closeSuccessNavigate"
                  class="text-center ma-1"
                  width="100%"
                  dark
                  text
                  small
                >
                  <span class="text-capitalize">Cancel</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </ValidationObserver>
      </v-card>
      <!-- dialog success -->
      <v-dialog v-model="dialog" persistent max-width="350">
        <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
          <v-icon color="green" size="100px">mdi-checkbox-marked-circle</v-icon>
          <v-card-title class="title-card mx-auto text-center"
            >Update Picture Profile Success</v-card-title
          >
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              @click.prevent="closeSuccessNavigate"
              color="green"
              :loading="loading"
              class="mt-3 w-full"
              width="100%"
              dark
            >
              <span class="text-capitalize">Okay</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- dialog failed -->
      <v-dialog v-model="dialog2" persistent max-width="350">
        <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
          <v-icon color="#F32626" size="100px">mdi-alert-circle-outline</v-icon>
          <v-card-title class="title-card mx-auto text-center"
            >Update Picture Profile Failed</v-card-title
          >
          <p class="mx-auto">{{ errorMessage }}</p>
          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn
              @click.prevent="dialog2 = false"
              color="green"
              class="mt-3 w-full"
              width="100%"
              dark
            >
              <span class="text-capitalize">Okay</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const user = createNamespacedHelpers("login");
export default {
  name: "profile",
  data() {
    return {
      tab: null,
      dates: [],
      password: null,
      confirmation: null,
      currentPass: null,
      dialog2: false,
      dialog: false,
      show1: false,
      show2: false,
      loading: false,
      e1: 1,
      images: null,
      errorMessage: false,
      image: null
    };
  },
  watch: {},
  computed: {
    ...user.mapState(["res_userInfo"])
  },
  components: {},
  mounted() {
    this.$store.dispatch("login/getUserInfo");
  },
  methods: {
    onTagValueChange(e) {
      this.employeeName = e.employee_name;
      this.posisition = e.posisition;
    },
    closeSuccessNavigate() {
      this.dialog = false;
      this.$router.push("/dashboard");
    },
    handleFileChange() {
      // this.image = e.File
      // console.log(this.image)
    },
    goBack() {
      this.$router.push("/dashboard");
    },
    submitForm() {
      console.log(this.image);
      // button effect
      this.loading = true;

      let param = new FormData();
      param.append("username", this.res_userInfo.username);
      param.append("image", this.image);

      this.$store.commit("login/SET_TEMPINPUT", param);
      this.$store
        .dispatch("login/putChangeProfile")
        .then(response => {
          const res = response.data;
          console.log(res);
          if (res.message === "Success Update Profile") {
            this.dialog = true;
            this.loading = false;
          } else {
            this.dialog2 = true;
            this.loading = false;
          }
        })
        .catch(error => {
          const message = error.response.data.status.message;
          this.errorMessage = message;
          this.dialog2 = true;
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
.theme--dark.v-icon {
  color: #000000;
}
.theme--dark.v-icon.v-icon.v-icon--disabled {
  color: rgb(2 2 2 / 31%) !important;
}
</style>
